module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./WechatPayAuthView.js"));
	}, "WechatPayAuthView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=WechatPayAuthView!./src/pages/Shop/WechatAuth/WechatPayAuthView.js
// module id = 1382
// module chunks = 418